import { api } from 'api'

export async function fetchIsSubmissionOutdated(datasetId: string) {
  const { data } = await api.get<boolean>(`/api/core/v1/datasets/${datasetId}/outdated`)
  return data
}
